// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"responsive-settings-modulewrapperNX6"};